import React from "react";
import Container from "./Components/Container";

function App() {
  return (
    <div className='App min-h-screen p-10 flex justify-center items-center bg-VeryDarkBlue overflow-auto relative'>
      <Container />
    </div>
  );
}

export default App;
